import { createFileRoute } from '@tanstack/react-router'

import { InputDimensionsDocumentationPageSkeleton } from '#/modules/documentation/back-office/input-dimensions-documentation-page/input-dimensions-documentation-page-skeleton.tsx'
import { InputDimensionsDocumentationPage } from '#/modules/documentation/back-office/input-dimensions-documentation-page/input-dimensions-documentation-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/documentation/input-dimensions')({
  beforeLoad: ({ context }) => requirePermissions(context, ['documentation.read']),
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(context.trpc.dev.getInputDimensionsPerProduct.queryOptions()),
  pendingComponent: InputDimensionsDocumentationPageSkeleton,
  component: InputDimensionsDocumentationPage,
})
